import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

// Create loading context
export const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [loadingState, setLoadingState] = useState({
    isLoading: false,
    message: 'Loading...',
  });
  
  // Set loading state
  const setLoading = useCallback((isLoading, message = 'Loading...') => {
    setLoadingState({ isLoading, message });
  }, []);
  
  // Start loading with message
  const startLoading = useCallback((message = 'Loading...') => {
    setLoadingState({ isLoading: true, message });
  }, []);
  
  // Stop loading
  const stopLoading = useCallback(() => {
    setLoadingState({ isLoading: false, message: '' });
  }, []);
  
  const value = useMemo(
    () => ({
      ...loadingState,
      setLoading,
      startLoading,
      stopLoading
    }),
    [loadingState, setLoading, startLoading, stopLoading]
  );

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};